import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CancelPendingBooking } from "../../model/IndexModel";
import Header from "../layout/Header";
import Footer from "../layout/Footer";

const PaymentCancelled = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("cancelling"); // 'cancelling' | 'done' | 'error'

  useEffect(() => {
    const ptoken = searchParams.get("ptoken");
    if (!ptoken) {
      setStatus("done");
      return;
    }
    CancelPendingBooking(ptoken)
      .then(() => setStatus("done"))
      .catch(() => setStatus("done")); // Either way the UI shows cancelled
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Header />
      <div
        className="container d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "60vh", textAlign: "center" }}
      >
        {status === "cancelling" ? (
          <p>Cancelling your booking...</p>
        ) : (
          <>
            <div style={{ fontSize: "3rem", color: "#eb2a25", marginBottom: "16px" }}>
              &#x2715;
            </div>
            <h2 style={{ marginBottom: "12px" }}>Payment Cancelled</h2>
            <p style={{ color: "#555", maxWidth: "440px", marginBottom: "28px" }}>
              Your payment was not completed and your booking has been cancelled.
              The time slot has been released and is available for others to book.
            </p>
            <div className="d-flex gap-3 justify-content-center flex-wrap">
              <button
                className="btn btn-outline-secondary"
                onClick={() => navigate(-1)}
              >
                Go Back
              </button>
              <button
                className="btn btn-danger"
                style={{ backgroundColor: "#eb2a25", borderColor: "#eb2a25" }}
                onClick={() => navigate("/")}
              >
                Browse Halls
              </button>
            </div>
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

export default PaymentCancelled;
